<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <br />
    <br />
    <div class="payroll-cards">
      <div class="pay-register-class">
        <tl-header type="h3" class="head">Pay Register</tl-header>
        <div class="pay-register">
            <div class="small">
              <!-- <line-chart :chart-data="datacollection"></line-chart> -->
              <canvas id="line-chart"></canvas>
              <div class="bottom">
                <div>
                    <p><span>Total Employees:</span>
                    <br>
                    <span><b>40,000</b></span></p>
                </div>
                <div>
                    <p><span>Net Pay:</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
                <div>
                    <p><span>Total Earnings:</span>
                    <br>
                    <span><b>10,000</b></span></p>
                    <p class="increase"><b>12%</b> Since<br>Last month</p>
                </div>
                <div>
                    <p><span>Total Deductions:</span>
                    <br>
                    <span><b>10,000</b></span></p>
                    <p class="increase"><b>12%</b> Since<br>Last month</p>
                </div>
              </div>
              <div class="reports">
                <div @click="viewReports"><b>Download Reports</b></div>
              </div>
            </div>
        </div>
      </div>
      <div class="dis-medium">
        <tl-header type="h3" class="head">Distribution Medium</tl-header>
        <div class="pay-register">
            <div class="small">
              <canvas id="doughnut-chart"></canvas>
              <div class="bottom2">
                <div>
                    <p><span>By Transfer:</span>
                    <br>
                    <span><b>40,000</b></span></p>
                </div>
                <div>
                    <p><span>By Cheque:</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
                <div>
                    <p><span>By Cash:</span>
                    <br>
                    <span><b>10,000</b></span></p>
                    <p class="increase"><b>12%</b> Since<br>Last month</p>
                </div>
              </div>
              <div class="dis-reports">
                <div @click="viewReports"><b>Download Reports</b></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div>
    <div class="payroll-cards2">
      <div class="variance-analysis">
        <tl-header type="h3" class="head">Variance Analysis</tl-header>
        <div class="pay-register">
            <div class="small2">
              <canvas class="horz_canvas" id="horizontal_bar_chart"></canvas>
              <div class="bottom3">
                <div>
                    <p><span>Current Month Amount</span>
                    <br>
                    <span><b>40,000</b></span></p>
                </div>
                <div>
                    <p><span>Previous Month Amount</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
                <div>
                    <p><span>Variance Amount</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
              </div>
              <div class="va-reports">
                <div @click="viewReports"><b>Download Reports</b></div>
              </div>
            </div>
        </div>

      </div>
      <div class="joinings-exits">
        <tl-header type="h3" class="head">Joinings & Exits</tl-header>
        <div class="pay-register">
            <div class="small">
              <div class="top-label">
                <button @click="prevMonth()"><img class="left-arrow" src="@/assets/prev-icon.png" /></button>
                 {{selectedMonth}}
                <button @click="nextMonth()"><img class="right-arrow" src="@/assets/next-icon.png" /></button>
              </div>
              <div class="multi-line-chart"><canvas id="multi-line-chart"></canvas></div>
              <div class="legends">
                <div id="js-legend" class="chart-legend"></div>
                <span class="span-name">Employee Joins</span>
                <div id="js-legend" class="chart-legend2"></div>
                <span class="span-name">Employee Exits</span>
              </div>
              <div class="bottom4">
                <div>
                    <p><span>New Joinees</span>
                    <br>
                    <span><b>40,000</b></span></p>
                </div>
                <div>
                    <p><span>Exits</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
              </div>
              <div class="joinings-exits-reports">
                <div @click="viewReports"><b>Download Reports</b></div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="payroll-card3">
      <div class="headcount">
        <tl-header type="h3" class="head">Headcount Report</tl-header>
        <div class="bottom5">
                <div>
                    <p><span>Total Employees</span>
                    <br>
                    <span><b>40,000</b></span></p>
                </div>
                <div>
                    <p><span>Existing Employees</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
                <div>
                    <p><span>New Joinees</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
                <div>
                    <p><span>Exits</span>
                    <br>
                    <span><b>10,000</b></span></p>
                </div>
              </div>
              <div class="headcount-report">
                <div @click="viewReports"><b>Download Reports</b></div>
              </div>
      </div>
    </div>
    </div>
        <div class="lineChart">
          <ul class="example-item">
            <li>
              <a href="javascript:void(0)" v-on:click="goToLeavesPage">Download Monthly Payroll Report</a>
            </li>
          </ul>
        </div>
  </div>
</template>

<script>
import Chart from "chart.js";
export default {
  // components: {
  //   LineChart
  // },
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Reports",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/`
        },
        {
          name: "Payroll Report",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/payrollReport`
        }
      ],
      count: 1,
      selectedMonth : 'January',
    };
  },
  mounted() {
    this.createLineChart("line-chart");
    this.createBarChart("horizontal_bar_chart");
    this.createDoughnutChart("doughnut-chart");
    this.createMultiLineChart("multi-line-chart");
  },
  methods: {
    prevMonth(count) {
      // console
      this.count++
      // for(var i=1;i<=this.count;i++){
        if(count==1){ this.selectedMonth = 'January' }
        if(count==2){ this.selectedMonth = 'February'}
        if(count==3){ this.selectedMonth = 'March' }
        if(count==4){ this.selectedMonth = 'April' }
        if(count==5){ this.selectedMonth = 'May' }
        if(count==6){ this.selectedMonth = 'June' }
        if(count==7){ this.selectedMonth = 'July' }
        if(count==8){ this.selectedMonth = 'August' }
        if(count==9){ this.selectedMonth = 'September' }
        if(count==10){ this.selectedMonth = 'October' }
        if(count==11){ this.selectedMonth = 'November' }
        if(count==12){ this.selectedMonth = 'December' }
      // }
      //console.log(this.selectedMonth)
    },
    nextMonth(count) {
      this.count++
      // for(var i=1;i<=count;i++){
        if(count==1){ this.selectedMonth = 'January' }
        if(count==2){ this.selectedMonth = 'February'}
        if(count==3){ this.selectedMonth = 'March' }
        if(count==4){ this.selectedMonth = 'April' }
        if(count==5){ this.selectedMonth = 'May' }
        if(count==6){ this.selectedMonth = 'June' }
        if(count==7){ this.selectedMonth = 'July' }
        if(count==8){ this.selectedMonth = 'August' }
        if(count==9){ this.selectedMonth = 'September' }
        if(count==10){ this.selectedMonth = 'October' }
        if(count==11){ this.selectedMonth = 'November' }
        if(count==12){ this.selectedMonth = 'December' }
      // }
      //console.log(this.selectedMonth)
    },
    createLineChart(chartId) {
      var chart = document.getElementById(chartId).getContext("2d");
      var gradient = chart.createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0, "rgba(52, 192,190, 1)");
      gradient.addColorStop(0.3, "rgba(153, 227, 231, 0.3)");
      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

      var data = {
        labels: ["January", "February", "March", "April", "May", "June"],
        datasets: [
          {
            // label: 'Custom Label Name',
            backgroundColor: gradient,
            pointBackgroundColor: "white",
            borderWidth: 1,
            borderColor: "#34c0be",
            data: [50, 55, 80, 81, 54, 50]
          }
        ]
      };

      var options = {
        responsive: true,
        maintainAspectRatio: true,
        // animation: {
        //   easing: 'easeInOutQuad',
        //   duration: 520
        // },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(200, 200, 200, 0)",
                lineWidth: 1
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                color: "rgba(200, 200, 200, 0.08)",
                lineWidth: 1
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.4
          },
          point: {
            radius: 0
          }
        },
        legend: {
          display: false
        },
        tooltips: {
          titleFontFamily: "Open Sans",
          backgroundColor: "rgba(0,0,0,0.3)",
          titleFontColor: "red",
          caretSize: 5,
          cornerRadius: 2,
          xPadding: 10,
          yPadding: 10
        }
      };
      var chartInstance = new Chart(chart, {
        type: "line",
        data: data,
        options: options
      });
    },
    createBarChart(chartId) {
      Chart.elements.Rectangle.prototype.draw = function() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var left, right, top, bottom, signX, signY, borderSkipped, radius;
        var borderWidth = vm.borderWidth;
        // Set Radius Here
        // If radius is large enough to cause drawing errors a max radius is imposed
        var cornerRadius = 30;

        if (!vm.horizontal) {
          // bar
          left = vm.x - vm.width / 2;
          right = vm.x + vm.width / 2;
          top = vm.y;
          bottom = vm.base;
          signX = 1;
          signY = bottom > top ? 1 : -1;
          borderSkipped = vm.borderSkipped || "bottom";
        } else {
          // horizontal bar
          left = vm.base;
          right = vm.x;
          top = vm.y - vm.height / 2;
          bottom = vm.y + vm.height / 2;
          signX = right > left ? 1 : -1;
          signY = 1;
          borderSkipped = vm.borderSkipped || "left";
        }

        // Canvas doesn't allow us to stroke inside the width so we can
        // adjust the sizes to fit if we're setting a stroke on the line
        if (borderWidth) {
          // borderWidth shold be less than bar width and bar height.
          var barSize = Math.min(
            Math.abs(left - right),
            Math.abs(top - bottom)
          );
          borderWidth = borderWidth > barSize ? barSize : borderWidth;
          var halfStroke = borderWidth / 2;
          // Adjust borderWidth when bar top position is near vm.base(zero).
          var borderLeft =
            left + (borderSkipped !== "left" ? halfStroke * signX : 0);
          var borderRight =
            right + (borderSkipped !== "right" ? -halfStroke * signX : 0);
          var borderTop =
            top + (borderSkipped !== "top" ? halfStroke * signY : 0);
          var borderBottom =
            bottom + (borderSkipped !== "bottom" ? -halfStroke * signY : 0);
          // not become a vertical line?
          if (borderLeft !== borderRight) {
            top = borderTop;
            bottom = borderBottom;
          }
          // not become a horizontal line?
          if (borderTop !== borderBottom) {
            left = borderLeft;
            right = borderRight;
          }
        }

        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = borderWidth;

        // Corner points, from bottom-left to bottom-right clockwise
        // | 1 2 |
        // | 0 3 |
        var corners = [
          [left, bottom],
          [left, top],
          [right, top],
          [right, bottom]
        ];

        // Find first (starting) corner with fallback to 'bottom'
        var borders = ["bottom", "left", "top", "right"];
        var startCorner = borders.indexOf(borderSkipped, 0);
        if (startCorner === -1) {
          startCorner = 0;
        }

        function cornerAt(index) {
          return corners[(startCorner + index) % 4];
        }

        // Draw rectangle from 'startCorner'
        var corner = cornerAt(0);
        var width, height, x, y, nextCorner, nextCornerId;
        var x_tl, x_tr, y_tl, y_tr;
        var x_bl, x_br, y_bl, y_br;
        ctx.moveTo(corner[0], corner[1]);

        for (var i = 1; i < 4; i++) {
          corner = cornerAt(i);
          nextCornerId = i + 1;
          if (nextCornerId == 4) {
            nextCornerId = 0;
          }

          nextCorner = cornerAt(nextCornerId);

          width = corners[2][0] - corners[1][0];
          height = corners[0][1] - corners[1][1];
          x = corners[1][0];
          y = corners[1][1];

          radius = cornerRadius;

          // Fix radius being too large
          if (radius > Math.abs(height) / 2) {
            radius = Math.floor(Math.abs(height) / 2);
          }
          if (radius > Math.abs(width) / 2) {
            radius = Math.floor(Math.abs(width) / 2);
          }

          if (height < 0) {
            // Negative values in a standard bar chart
            x_tl = x;
            x_tr = x + width;
            y_tl = y + height;
            y_tr = y + height;

            x_bl = x;
            x_br = x + width;
            y_bl = y;
            y_br = y;

            // Draw
            ctx.moveTo(x_bl + radius, y_bl);
            ctx.lineTo(x_br - radius, y_br);
            ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
            ctx.lineTo(x_tr, y_tr + radius);
            ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr);
            ctx.lineTo(x_tl + radius, y_tl);
            ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
            ctx.lineTo(x_bl, y_bl - radius);
            ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
          } else if (width < 0) {
            // Negative values in a horizontal bar chart
            x_tl = x + width;
            x_tr = x;
            y_tl = y;
            y_tr = y;

            x_bl = x + width;
            x_br = x;
            y_bl = y + height;
            y_br = y + height;

            // Draw
            ctx.moveTo(x_bl + radius, y_bl);
            ctx.lineTo(x_br - radius, y_br);
            ctx.quadraticCurveTo(x_br, y_br, x_br, y_br - radius);
            ctx.lineTo(x_tr, y_tr + radius);
            ctx.quadraticCurveTo(x_tr, y_tr, x_tr - radius, y_tr);
            ctx.lineTo(x_tl + radius, y_tl);
            ctx.quadraticCurveTo(x_tl, y_tl, x_tl, y_tl + radius);
            ctx.lineTo(x_bl, y_bl - radius);
            ctx.quadraticCurveTo(x_bl, y_bl, x_bl + radius, y_bl);
          } else {
            //Positive Value
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(
              x + width,
              y + height,
              x + width - radius,
              y + height
            );
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
          }
        }

        ctx.fill();
        if (borderWidth) {
          ctx.stroke();
        }
      };

      var data = {
        labels: ["Red", "Blue", "Yellow"],
        datasets: [
          {
            label: "# of Votes",
            data: [12, 19, 3],
            backgroundColor: [
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 206, 86, 1)",
            ],
            borderWidth: 0
          }
        ]
      };
      var options = {
        showScale: false,
        responsive: true,
        legend: false,
        scales: {
          // barPercentage: 1,
          yAxes: [
            {
              barThickness: 40,
              categoryPercentage: 0.8,
              barPercentage: 0.9,
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      };

      var ctx = document.getElementById(chartId);
      var myHorizBarChart = new Chart(ctx, {
        type: "horizontalBar",
        data: data,
        options: options
      });
    },
    createDoughnutChart(chartId) {
      // round corners
      Chart.pluginService.register({
        afterUpdate: function(chart) {
          if (
            chart.config.options.elements.arc.roundedCornersFor !== undefined
          ) {
            var arc = chart.getDatasetMeta(0).data[
              chart.config.options.elements.arc.roundedCornersFor
            ];
            arc.round = {
              x: (chart.chartArea.left + chart.chartArea.right) / 2,
              y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
              radius: (chart.outerRadius + chart.innerRadius) / 2,
              thickness: (chart.outerRadius - chart.innerRadius) / 2 - 1,
              backgroundColor: arc._model.backgroundColor
            };
          }
        },

        afterDraw: function(chart) {
          if (
            chart.config.options.elements.arc.roundedCornersFor !== undefined
          ) {
            var ctx = chart.chart.ctx;
            var arc = chart.getDatasetMeta(0).data[
              chart.config.options.elements.arc.roundedCornersFor
            ];
            var startAngle = Math.PI / 2 - arc._view.startAngle;
            var endAngle = Math.PI / 2 - arc._view.endAngle;

            ctx.save();
            ctx.translate(arc.round.x, arc.round.y);
            //console.log(arc.round.startAngle);
            ctx.fillStyle = arc.round.backgroundColor;
            ctx.beginPath();
            ctx.arc(
              arc.round.radius * Math.sin(startAngle),
              arc.round.radius * Math.cos(startAngle),
              arc.round.thickness,
              0,
              2 * Math.PI
            );
            ctx.arc(
              arc.round.radius * Math.sin(endAngle),
              arc.round.radius * Math.cos(endAngle),
              arc.round.thickness,
              0,
              2 * Math.PI
            );
            ctx.closePath();
            ctx.fill();
            ctx.restore();
          }
        }
      });

      // write text plugin
      Chart.pluginService.register({
        afterUpdate: function(chart) {
          if (chart.config.options.elements.center) {
            var helpers = Chart.helpers;
            var centerConfig = chart.config.options.elements.center;
            var globalConfig = Chart.defaults.global;
            var ctx = chart.chart.ctx;

            var fontStyle = helpers.getValueOrDefault(
              centerConfig.fontStyle,
              globalConfig.defaultFontStyle
            );
            var fontFamily = helpers.getValueOrDefault(
              centerConfig.fontFamily,
              globalConfig.defaultFontFamily
            );

            if (centerConfig.fontSize) var fontSize = centerConfig.fontSize;
            // figure out the best font size, if one is not specified
            else {
              ctx.save();
              var fontSize = helpers.getValueOrDefault(
                centerConfig.minFontSize,
                1
              );
              var maxFontSize = helpers.getValueOrDefault(
                centerConfig.maxFontSize,
                256
              );
              var maxText = helpers.getValueOrDefault(
                centerConfig.maxText,
                centerConfig.text
              );

              do {
                ctx.font = helpers.fontString(fontSize, fontStyle, fontFamily);
                var textWidth = ctx.measureText(maxText).width;

                // check if it fits, is within configured limits and that we are not simply toggling back and forth
                if (textWidth < chart.innerRadius * 2 && fontSize < maxFontSize)
                  fontSize += 1;
                else {
                  // reverse last step
                  fontSize -= 1;
                  break;
                }
              } while (true);
              ctx.restore();
            }

            // save properties
            chart.center = {
              font: helpers.fontString(fontSize, fontStyle, fontFamily),
              fillStyle: helpers.getValueOrDefault(
                centerConfig.fontColor,
                globalConfig.defaultFontColor
              )
            };
          }
        },
        afterDraw: function(chart) {
          if (chart.center) {
            var centerConfig = chart.config.options.elements.center;
            var ctx = chart.chart.ctx;

            ctx.save();
            ctx.font = chart.center.font;
            ctx.fillStyle = chart.center.fillStyle;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;
            ctx.fillText(centerConfig.text, centerX, centerY);
            ctx.restore();
          }
        }
      });

      var ctx = document.getElementById(chartId).getContext("2d");
      var gradient = ctx.createLinearGradient(0, 0, 0, 450);

      gradient.addColorStop(0, "rgba(52, 192,190, 1)");
      gradient.addColorStop(0.3, "rgba(153, 227, 231, 0.3)");
      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

      var data = {
        labels: ["January", "February", "March"],
        datasets: [
          {
            backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
            hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
            borderWidth: 1,
            data: [50, 55, 80]
          }
        ]
      };

      var options = {
        responsive: true,
        maintainAspectRatio: true,
        // animation: {
        //   easing: 'easeInOutQuad',
        //   duration: 520
        // },
        //
        elements: {
          arc: {
            roundedCornersFor: 0
          },
          center: {
            text: "67%",
            fontColor: "#FF6684",
            fontFamily: "'Montserrat'",
            fontStyle: "normal",
            fontSize: 36
          }
        },
        legend: {
          display: true
        }
      };
      var chartInstance = new Chart(ctx, {
        type: "doughnut",
        data: data,
        options: options
      });

      //   $('#doughtnut-chart').on('click', function(event) {
      //   var activePoints = chartInstance.getElementsAtEvent(event);
      //   var addRadiusMargin = 10;
      //   if (activePoints.length > 0) {
      //     // update the newly selected piece
      //     activePoints[0]['_model'].innerRadius = activePoints[0]['_model'].innerRadius +
      //         addRadiusMargin;
      //     activePoints[0]['_model'].outerRadius = activePoints[0]['_model'].outerRadius +
      //         addRadiusMargin;
      //   }

      //   chartInstance.render(300, false);
      // }
    },
    createMultiLineChart(chartId) {
      var canvas = document.getElementById(chartId);
      var ctx = canvas.getContext("2d");
      // Global Options:
      Chart.defaults.global.defaultFontColor = "black";
      Chart.defaults.global.defaultFontSize = 16;

      var data = {
        labels: [ 1,2,3,4,5,6,7,8,9,10,11,12],
        datasets: [
          {
            label: 'Employee Joins',
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(52, 192,190, 1)",
            borderColor: "rgba(52, 192,190, 1)",
            borderCapStyle: "square",
            borderDash: [], // try [5, 15] for instance
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(52, 192,190, 1)",
            pointBackgroundColor: "white",
            pointBorderWidth: 1,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: "white",
            pointHoverBorderColor: "rgba(52, 192,190, 1)",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 4,
            // notice the gap in the data and the spanGaps: true
            data: [65, 59, 80, 81, 56, 55, 40, 60, 55, 30, 78],
            spanGaps: true
          },
          {
            label: 'Employee Exits',
            fill: false,
            lineTension: 0.1,
            backgroundColor: "rgba(173,173,173,1)",
            borderColor: "rgba(173,173,173,1)",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(173,173,173,1)",
            pointBackgroundColor: "white",
            pointBorderWidth: 1,
            pointHoverRadius: 4,
            pointHoverBackgroundColor: "white",
            pointHoverBorderColor: "rgba(173,173,173,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 4,
            // notice the gap in the data and the spanGaps: false
            data: [10, 20, 60, 95, 64, 78, 90, 70, 40, 70, 89],
            spanGaps: false
          }
        ]
      };

      // Notice the scaleLabel at the same level as Ticks
      var options = {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true,
                drawBorder: false,
                borderDash: [2, 4],
                // tickMarkLength:
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        }
      };

      // Chart declaration:
      var myBarChart = new Chart(ctx, {
        type: "line",
        data: data,
        options: options
      });
    },
    viewReports() {
      //console.log('inside view reports')
      this.$router.push(`/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/payrollreport`)
    },
  }
};
</script>

<style lang="scss" scoped>
.payroll-cards {
  display: flex;
}
.type {
  display: flex;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
  }
}
.head {
  padding: 30px;
}
.small {
  max-width: 600px;
  // margin: 150px auto;
  margin-top: 10px;
  margin-left: 30px;
  // justify-c
}
.pay-register-class {
  margin-right: 1.1%;
  width: 869px;
  height: 546px;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #efefef;
  background-color: #ffffff;
}
.legends {
  width: 1000px;
  display: flex;
  margin-bottom: 2.1%;
}
.chart-legend{
  border-radius: 25px;
  border: 2px solid #34c0be;
  background: #34c0be;
  width: 25px;
  height: 15px;
  display: flex;
  margin-left: 100px;
}
.span-name {
    width: 200px;
    height: 15px;
    font-family: Montserrat;
    font-size: 12px;
    margin-left: 5px;
    color: #606060;
  }
.chart-legend2{
  border-radius: 25px;
  border: 2px solid #606060;
  background: #606060;
  width: 25px;
  height: 15px;
  display: flex;
}
.bottom{
    display: grid;
    margin-left: -30px;
    grid-template: 65px /repeat(4,1fr);
    width: 52.7vw;
    // grid-gap: 170px;
    margin-top:15px;
    border-bottom: 2px solid #eeeeee;
    border-top: 2px solid #eeeeee;
  div{
     display: flex;
     justify-content: center;
     align-items: center;
     color:#6e6e6e;
     padding-top: 15px;
     border-right:  2px solid #eeeeee;
     .increase{
        color: #1db25f;
        font-size: 10px;
        // margin-left: 20px;
        b{
            font-size: 14px;
        }

     }
  }
}
.reports{
  display: grid;
  grid-template: 70px /repeat(1,10fr);
  width: 50.4vw;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#6e6e6e;
    color: #5d409f;
    border-right:  2px solid #eeeeee;
    cursor: pointer;
    &:hover{
      background-color: #dadada
    }
  }
}
.dis-medium {
  width: 428px;
  height: 545px;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #efefef;
  background-color: #ffffff;


}
.bottom2{
    display: grid;
    margin-left: -30px;
    margin-top: 117px;
    grid-template: 65px /repeat(3,1fr);
    width: 32.9vw;
    // grid-gap: 170px;
    // margin-top:-20px;
    border-bottom: 2px solid #eeeeee;
    border-top: 2px solid #eeeeee;
    div{
      display: flex;
      justify-content: center;
      align-items: center;
      color:#6e6e6e;
      padding-top: 15px;
      border-right:  2px solid #eeeeee;
      .increase{
          color: #1db25f;
          font-size: 10px;
          // margin-left: 20px;
          b{
              font-size: 14px;
          }

      }
    }
  }
.dis-reports{
  display: grid;
  grid-template: 70px /repeat(1,10fr);
  width: 30.7vw;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#6e6e6e;
    color: #5d409f;
    border-right:  2px solid #eeeeee;
    cursor: pointer;
    &:hover{
      background-color: #dadada
    }
  }
}
.payroll-cards2 {
  display: flex;
}
.variance-analysis{
  margin-top: 16px;
  width: 689px;
  height: 368px;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #efefef;
  background-color: #ffffff;

}
.small2 {
  margin-top: -30px;
  margin-left: 30px;
}
.horz_canvas {
  display: block;
  width: 600px !important;
  height: 200px !important;
}
.bottom3{
    display: grid;
    margin-left: -30px;
    grid-template: 65px /repeat(3,1fr);
    width: 53vw;
    // grid-gap: 170px;
    // margin-top:-20px;
    border-bottom: 2px solid #eeeeee;
    border-top: 2px solid #eeeeee;
    div{
      display: flex;
      justify-content: center;
      align-items: center;
      color:#6e6e6e;
      padding-top: 15px;
      border-right:  2px solid #eeeeee;
    }
  }
.va-reports{
  display: grid;
  grid-template: 45px /repeat(1,10fr);
  width: 50.6vw;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#6e6e6e;
    color: #5d409f;
    border-right:  2px solid #eeeeee;
    cursor: pointer;
    &:hover{
      background-color: #dadada
    }
  }
}
.joinings-exits {
  width: 606px;
  height: 587px;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #efefef;
  background-color: #ffffff;
  margin-top: 16px;
  margin-left: 1.1%;
}
.top-label{
  justify-content: center;
  margin-top: 4.4%;
  margin-bottom: 5%;
  display: flex;

  .left-arrow {
    margin-right: 16px;
    cursor: pointer;
  }

  .right-arrow {
    margin-left: 16px;
    cursor: pointer;
  }
}
.multi-line-chart {
  margin-top: 10px;
}
.bottom4{
    display: grid;
    margin-left: -30px;
    grid-template: 65px /repeat(2,1fr);
    width: 34.9vw;
    // grid-gap: 170px;
    // margin-top:-20px;
    border-bottom: 2px solid #eeeeee;
    border-top: 2px solid #eeeeee;
    div{
      display: flex;
      justify-content: center;
      align-items: center;
      color:#6e6e6e;
      padding-top: 15px;
      border-right:  2px solid #eeeeee;
      .increase{
          color: #1db25f;
          font-size: 10px;
          // margin-left: 20px;
          b{
              font-size: 14px;
          }

      }
    }
  }
.joinings-exits-reports{
  display: grid;
  grid-template: 50px /repeat(1,10fr);
  width: 33.2vw;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#6e6e6e;
    color: #5d409f;
    border-right:  2px solid #eeeeee;
    cursor: pointer;
    &:hover{
      background-color: #dadada
    }
  }
}
.payroll-card3 {
  margin-top: -202px;
}
.headcount {
  width: 689px;
  height: 203px;
  border-radius: 8px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.07);
  border: solid 1px #efefef;
  background-color: #ffffff;
}
.bottom5{
    display: grid;
    // margin-left: -30px;
    grid-template: 65px /repeat(4,1fr);
    width: 52.9vw;
    // grid-gap: 170px;
    // margin-top:-20px;
    border-bottom: 2px solid #eeeeee;
    border-top: 2px solid #eeeeee;
    div{
      display: flex;
      justify-content: center;
      align-items: center;
      color:#6e6e6e;
      padding-top: 15px;
      border-right:  2px solid #eeeeee;
      .increase{
          color: #1db25f;
          font-size: 10px;
          // margin-left: 20px;
          b{
              font-size: 14px;
          }

      }
    }
  }
.headcount-report {
  display: grid;
  grid-template: 45px /repeat(1,10fr);
  width: 52.9vw;
  div{
    display: flex;
    justify-content: center;
    align-items: center;
    color:#6e6e6e;
    color: #5d409f;
    border-right:  2px solid #eeeeee;
    cursor: pointer;
    &:hover{
      background-color: #dadada
    }
  }
}
</style>
